import { Injectable, Injector } from '@angular/core';
import { Subject } from 'rxjs/Subject';

// import { AppSettings } from './../app.settings';

@Injectable()
export class CommonFunctionService {

	public loadingSpinner: Subject<boolean> = new Subject();

	// On window resize end
	public onWindowResizeEnd: Subject<any> = new Subject();
	constructor() {}

	setLoadingSpinner(isLoading: boolean) {
		this.loadingSpinner.next(isLoading);
	}

}



// WEBPACK FOOTER //
// ./src/app/common-services/common-function.service.ts